import PersonalInfo from '../../profile/components/PersonalInfo.tsx'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { UserListQueries } from '@/queries/users/queries.ts'
import { usePageHeader } from '@/layouts/PageHeaderProvider.tsx'
import { useEffect, useRef } from 'react'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import UserPrograms from '../../profile/components/UserPrograms.tsx'
import { LogUserActivity } from '@/apis/users/requests.ts'
import { LOG_TYPES } from '@/common/constants.ts'

export default function UsersDetailView() {
  const { setTitle } = usePageHeader()
  const { userId } = useParams<{ userId?: string }>()
  const UserData = useQuery(UserListQueries.getUserById(userId!))
  const hasLoggedPageView = useRef(false)

  useEffect(() => {
    if (UserData.data?.first_name) {
      setTitle(`${UserData.data.first_name} ${UserData.data?.last_name}`)
    }
  }, [UserData.data?.first_name])

  useEffect(() => {
    if (!hasLoggedPageView.current && UserData?.data) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: 'details',
        targetUserName: `${UserData.data?.first_name} ${UserData.data?.last_name} (USER)`,
      }) // Log page view
      hasLoggedPageView.current = true // Mark as executed
    }
  }, [])

  if (UserData.error) {
    return <div>{UserData.error?.message ?? ''}</div>
  }

  return (
    <div className="container-fixed flex grow gap-5 lg:gap-7.5">
      {/* Main Content */}
      <div className="flex flex-col items-stretch grow gap-5 lg:gap-7.5">
        {(function () {
          if (!UserData.data) return ''
          return (
            <>
              <PersonalInfo
                {...UserData.data}
                callBackUrl={AppRoutePaths.setup.users.index}
              />
              <UserPrograms userId={UserData.data?.id} />
            </>
          )
        })()}
      </div>
    </div>
  )
}
